import './style/index.less';
import Phone from './Phone';

export default Phone;
